export default __webpack_public_path__ + "static/media/avatar5.9b1c3b31.png";